import { createAction } from "redux-actions";

export const setActiveItinerary = createAction("SET_ACTIVE_ITINERARY");
export const setActivePreviewItinerary = createAction(
  "SET_ACTIVE_PREVIEW_ITINERARY"
);
export const setActiveLeg = createAction("SET_ACTIVE_LEG");
export const setActiveStep = createAction("SET_ACTIVE_STEP");
